module.exports = __webpack_public_path__ + "img/09-img.aa529945.jpg";